/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IRevisionHistoryReconnectMessage extends IMessage {
	documentId: string;
	requestId: number;
}

export default class RevisionHistoryReconnectMessage extends Message {
	public static readonly TYPE: string = '122';

	public static readonly READABLE_TYPE_NAME: string = 'reconnectToRevisionHistory';

	public static readonly DESCRIPTOR_NAME: string = 'RevisionHistoryReconnectMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			documentId: {
				type: 'string',
				id: 1
			},
			requestId: {
				type: 'uint32',
				id: 2
			}
		}
	};

	public constructor( public readonly documentId: string, public readonly requestId: number ) {
		super();
	}

	public toJSON(): IRevisionHistoryReconnectMessage {
		return {
			documentId: this.documentId,
			requestId: this.requestId
		};
	}

	public static fromJSON( object: IRevisionHistoryReconnectMessage ): RevisionHistoryReconnectMessage {
		return new RevisionHistoryReconnectMessage( object.documentId, object.requestId );
	}
}
